"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PaymentHistoryItem;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/es-us");
require("moment/locale/en-gb");
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _client = _interopRequireDefault(require("@sart/client"));
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
var _StoredPaymentMethod = _interopRequireDefault(require("./StoredPaymentMethod"));
var getProductRenewDate = function getProductRenewDate(startDate, frequency, frequencyUnit) {
  var renewDate = (0, _moment["default"])(startDate).utc();
  while (renewDate.diff((0, _moment["default"])().utc()) < 0) {
    renewDate = renewDate.add(frequency, frequencyUnit.toLowerCase());
  }
  return renewDate;
};
var formatDate = function formatDate(date, language) {
  if (date) {
    var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function PaymentHistoryItem(props) {
  var _payment$status, _payment$type;
  var payment = props.payment;
  var content = (0, _content.useContent)();
  var language = 'en-gb';
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, content.profile_payment.paymentDate), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, formatDate(payment.created, language))), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, content.profile_payment.amount), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, "\xA3", payment.amount)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, content.profile_payment.status), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, (_payment$status = payment.status) === null || _payment$status === void 0 ? void 0 : _payment$status.toUpperCase()))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, content.profile_payment.type), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, (_payment$type = payment.type) === null || _payment$type === void 0 ? void 0 : _payment$type.toUpperCase())), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.columnReference
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, content.profile_payment.reference), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, payment.id))), payment.discount && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: styles.label
  }, "Applied Discounts"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.text
  }, payment.discount.promo_code, " - ", payment.discount.coupon)))));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    padding: 14,
    backgroundColor: _styles.backgroundColors.darkCharcoal,
    borderRadius: _styles.radius.medium,
    elevation: 8,
    borderColor: _styles.colors.white,
    borderWidth: 1
  },
  name: {
    fontSize: 12,
    lineHeight: 28,
    fontWeight: '700',
    color: _styles.colors.white
  },
  row: {
    flexDirection: 'row'
  },
  column: {
    flex: 1,
    flexDirection: 'column'
  },
  columnReference: {
    flex: 2,
    flexDirection: 'column'
  },
  label: {
    fontSize: 12,
    lineHeight: 16
  },
  text: {
    fontSize: 12,
    lineHeight: 28,
    color: _styles.colors.white
  },
  cancel: {
    color: _styles.colors.trivial,
    textAlign: 'center'
  }
});